import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findPurchase, fetchPurchaseLineItems } from '../actions/purchases';
import { findPurchaseOrders } from '../actions/orders';
import { findUser } from '../actions/users';
import { findSub } from '../actions/subs';
import { findAttSub } from '../actions/attSubs';
import { findTracfoneSub } from '../actions/tracfoneSubs';
import { findSimoSub } from '../actions/simoSubs';
import withPurchase from './withPurchase';
import { shallowEqual } from 'helpers/objects';
import { getSubIdWithCarrierFromLineitem, getUniqSubs } from 'helpers/subs';
import getCarrier from 'helpers/getCarrier';

const purchasePage = (DecoratedComponent) => {
  class PurchasePage extends Component {
    componentDidMount() {
      const { lineItemsPage, filters } = this.props;

      this.fetchPurchase();
      this.findPurchaseOrders();

      let isFilters;
      for (const key in filters) {
        const value = filters[key];
        if (value) {
          isFilters = true;
          break;
        }
      }

      if ((lineItemsPage && lineItemsPage.toString() !== '1') || isFilters) {
        this.fetchLineItems();
      }
    }

    componentDidUpdate(oldProps) {
      if (this.props.purchaseId !== oldProps.purchaseId) {
        this.fetchPurchase();
      }

      if (
        this.props.purchase &&
        oldProps.purchase &&
        oldProps.purchase.status !== 'complete' &&
        this.props.purchase.status === 'complete'
      ) {
        this.fetchSubsFromLineItems();
      }

      if (this.props.lineItemsPage !== oldProps.lineItemsPage) {
        this.fetchLineItems();
      } else if (!shallowEqual(this.props.filters, oldProps.filters)) {
        this.fetchLineItems();
      }
    }

    fetchPurchase() {
      const { findPurchase, findUser, purchaseId } = this.props;
      findPurchase(purchaseId).then((purchase) => {
        if (purchase) {
          findUser(purchase.user_profile);
          this.fetchSubsFromLineItems(purchase.line_items);
        }
      });
    }

    fetchLineItems() {
      const {
        fetchPurchaseLineItems,
        purchaseId,
        lineItemsPage = '1',
        filters,
      } = this.props;
      fetchPurchaseLineItems(purchaseId, lineItemsPage, filters);
    }

    findPurchaseOrders() {
      const { findPurchaseOrders, purchaseId } = this.props;
      findPurchaseOrders(purchaseId);
    }

    fetchSubsFromLineItems = (newLineItems) => {
      const {
        lineItems,
        subs,
        purchase,
        findSub,
        findAttSub,
        findTracfoneSub,
        findSimoSub,
      } = this.props;
      if (!purchase || purchase.status !== 'complete') {
        return;
      }

      let lineItemsForSubs = newLineItems || lineItems;
      // only for the plan update line item
      lineItemsForSubs = lineItemsForSubs.filter(
        (item) =>
          (item.att_plan || item.simo_plan) && !item.from_date && !item.to_date,
      );

      let subsToFetch = lineItemsForSubs
        .map(getSubIdWithCarrierFromLineitem)
        .filter((sub) => sub.id);
      subsToFetch = getUniqSubs(subsToFetch).filter(
        (subToFetch) =>
          !subs.find(
            (sub) =>
              sub.id === subToFetch.id &&
              getCarrier(sub) === subToFetch.carrier,
          ),
      );

      subsToFetch.forEach((sub) => {
        if (sub.carrier === 'sprint') {
          findSub(sub.id);
        } else if (sub.carrier === 'att') {
          findAttSub(sub.id);
        } else if (sub.carrier === 'tracfone') {
          findTracfoneSub(sub.id);
        } else if (sub.carrier === 'simo') {
          findSimoSub(sub.id);
        }
      });
    };

    render() {
      const { children, ...props } = this.props;
      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapDispatchToProps = {
    findPurchaseOrders,
    findPurchase,
    fetchPurchaseLineItems,
    findUser,
    findSub,
    findAttSub,
    findTracfoneSub,
    findSimoSub,
  };

  PurchasePage = withPurchase(connect(null, mapDispatchToProps)(PurchasePage));

  return PurchasePage;
};

export default purchasePage;
